<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Instansi</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Instansi Anda</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<form @submit.prevent="submit">
									<div class="card-body" style="min-height:530px">									
										<div class="row form-row">
											<div class="col-12 col-md-12">
												<div class="form-group">
													<label>Nama Universitas / Sekolah <span class="text-danger">*</span></label>
													<input type="text" class="form-control" v-model="form.tempat_kerja" required>
												</div>
											</div>
											<div class="col-12 col-md-12">
												<div class="form-group">
													<label>Alamat Universitas / Sekolah <span class="text-danger">*</span></label>
													<input type="text" class="form-control" v-model="form.alamat" required>
												</div>
											</div>
											<div class="col-12 col-md-12">
												<div class="form-group">
													<label>Website Universitas / Sekolah</label>
													<input type="text" class="form-control" v-model="form.website">
												</div>
											</div>
											<div class="col-12 col-md-12">
												<div class="form-group">
													<label>Jabatan Anda</label>
													<input type="text" class="form-control" v-model="form.jabatan">
												</div>
											</div>
										</div>									
									</div>
									<div class="card-footer text-center">
										<button type="submit" class="btn btn-primary submit-btn" >Simpan Perubahan</button>
									</div>								
								</form>
							</div>
						</div>
					</div>
				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
export default {
    components: {
        Sidebar
    },
	name: 'Instansi',
	data() {
		return {
			form: {
				id_user:localStorage.getItem('idUser'),
				id_work:'',tempat_kerja:'',alamat: '',website:'',jabatan:''	
			},
			errors: null,
			mesg: null
		}
	},
	mounted() {
		axios.get('api/userinstansi/'+localStorage.getItem('idUser')).then(response => {
			if(response.data.status != "error")
				this.form = response.data.data
		})
	},
	methods: {
        submit(){
            axios.post('api/userinstansiupdate', this.form)
                .then(function( response ){
					if(response.data.status == "error"){
						this.errors = response.data.data;
					} else {
						swal.fire(
							'Sukses!',
							'Simpan perubahan berhasil!',
							'success'
						);
					}
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/Instansi/index.vue